(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["constellation-libra-prototype"]) return;
  try {
    
document.querySelectorAll('.clp').forEach(root=>{
  const track=root.querySelector('.clp-track'), slides=[...root.querySelectorAll('.clp-slide')], thumbs=[...root.querySelectorAll('[data-index]')];
  if(!track || slides.length<2){root.querySelector('.clp-gallery-controls')?.setAttribute('hidden','');return;}
  const go=index=>track.scrollTo({left:Math.max(0,Math.min(slides.length-1,index))*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  thumbs.forEach(button=>button.addEventListener('click',()=>go(Number(button.dataset.index))));
  root.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>go(Math.round(track.scrollLeft/track.clientWidth)+Number(button.dataset.direction))));
  track.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();go(Math.round(track.scrollLeft/track.clientWidth)+(event.key==='ArrowRight'?1:-1));}});
  track.addEventListener('scroll',()=>{const index=Math.round(track.scrollLeft/track.clientWidth);thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));},{passive:true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equestrian-main-product"]) return;
  try {
    
if (!customElements.get('eq-product-gallery')) {
  customElements.define('eq-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.eq-product__track');
      const slides = [...this.querySelectorAll('.eq-product__slide')];
      const buttons = [...this.querySelectorAll('[data-slide]')];
      let current = 0;
      const go = index => {
        current = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({left: current * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => go(current + Number(button.dataset.direction))));
      buttons.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.slide))));
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      track.addEventListener('scroll', () => {
        current = Math.round(track.scrollLeft / track.clientWidth);
        buttons.forEach((button,index) => button.setAttribute('aria-current', String(index === current)));
      }, {passive: true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equestrian-product-treatment"]) return;
  try {
    
if (!customElements.get('eq-product-gallery')) {
  customElements.define('eq-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.eq-product__track');
      const slides = [...this.querySelectorAll('.eq-product__slide')];
      const buttons = [...this.querySelectorAll('[data-slide]')];
      let current = 0;
      const go = index => {
        current = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({left: current * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => go(current + Number(button.dataset.direction))));
      buttons.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.slide))));
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      track.addEventListener('scroll', () => {
        current = Math.round(track.scrollLeft / track.clientWidth);
        buttons.forEach((button,index) => button.setAttribute('aria-current', String(index === current)));
      }, {passive: true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
     this.closeMenuDisclosure();
      //this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

  }

 customElements.define('sticky-header', StickyHeader);

function startTypingEffect() {
    let text = document.querySelector('.search-with-predictive-search predictive-search label')?.textContent || ""; 
    let labels = document.querySelectorAll('.search-with-predictive-search predictive-search label');

    labels.forEach(label => {
        let index = 0;

        function typeText() {
            label.innerHTML = ""; 
            index = 0;

            function typingLoop() {
                if (index < text.length) {
                    label.innerHTML += text.charAt(index);
                    index++;
                    setTimeout(typingLoop, 100); 
                } else {
                    setTimeout(typeText, 5000); 
                }
            }

            typingLoop(); 
        }

        typeText();
    });
}


window.onload = startTypingEffect;



  } catch(e) { console.error(e); }
})();
})();
